import * as ActionsTypes from "../../../../common/constants/stateConstants";
import {
    noContentElementInitialState,
    objectContentElementInitialState,
    updateState,
} from "../../../../common/utils/helpers";

const initialState = {
  souscriptionToModify: { ...objectContentElementInitialState },
  envoiModificationSouscription: { ...noContentElementInitialState },
};

/*-------------------------------------------------GET-SOUSCRIPTION-TO-MODIFY----------------------------------------------------*/
const getSouscriptionToModify = (state) => {
  return updateState("souscriptionToModify", state, {
    ...objectContentElementInitialState,
    isLoading: true,
  });
};

const getSouscriptionToModifySuccess = (state, payload) => {
  return updateState("souscriptionToModify", state, {
    content: payload,
    isLoading: false,
    isSuccessed: true,
  });
};

const getSouscriptionToModifyFail = (state, payload) => {
  return updateState("souscriptionToModify", state, {
    error: payload,
    isLoading: false,
    hasError: true,
  });
};

/*-------------------------------------------------MODIFICATION-SOUSCRIPTION----------------------------------------------------*/
const modificationSouscription = (state) => {
  return updateState("envoiModificationSouscription", state, {
    ...noContentElementInitialState,
    isLoading: true,
  });
};

const modificationSouscriptionSuccess = (state) => {
  return updateState("envoiModificationSouscription", state, {
    isLoading: false,
    isSuccessed: true,
  });
};

const modificationSouscriptionFail = (state, payload) => {
  return updateState("envoiModificationSouscription", state, {
    error: payload,
    isLoading: false,
    hasError: true,
  });
};

const modificationSouscriptionReinitialization = (state) => {
  return updateState("envoiModificationSouscription", state, {
    ...noContentElementInitialState,
  });
};

/*************************************************************************** */
const modificationSouscriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    /*-------------------------------------------------GET-SOUSCRIPTION-TO-MODIFY----------------------------------------------------*/
    case ActionsTypes.GET_SOUSCRIPTION_TO_MODIFY:
      return getSouscriptionToModify(state, action);
    case ActionsTypes.GET_SOUSCRIPTION_TO_MODIFY_SUCCESS:
      return getSouscriptionToModifySuccess(state, action.payload);
    case ActionsTypes.GET_SOUSCRIPTION_TO_MODIFY_FAIL:
      return getSouscriptionToModifyFail(state, action.payload);
    /*-------------------------------------------------MODIFICATION-SOUSCRIPTION----------------------------------------------------*/
    case ActionsTypes.MODIFICATION_SOUSCRIPTION:
      return modificationSouscription(state, action);
    case ActionsTypes.MODIFICATION_SOUSCRIPTION_SUCCESS:
      return modificationSouscriptionSuccess(state);
    case ActionsTypes.MODIFICATION_SOUSCRIPTION_FAIL:
      return modificationSouscriptionFail(state, action.payload);
    case ActionsTypes.MODIFICATION_SOUSCRIPTION_REINITIALIZATION:
      return modificationSouscriptionReinitialization(state, action.payload);
    default:
      return state;
  }
};

export default modificationSouscriptionReducer;
